import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  es: {
    // Navbar
    nav: {
      convention: 'Convención',
      agenda: 'Agenda',
      speakers: 'Speakers',
      venue: 'Sede',
      press: 'Prensa',
      register: 'Nos vemos en 2027'
    },
    // Hero
    hero: {
      badge: 'Edición 20° Aniversario',
      title1: '20° Convención Nacional',
      title2: 'ASOFOM',
      subtitle: 'El encuentro más importante del sector financiero no bancario en México. El Legado nos une, el futuro nos mueve.',
      date: '26, 27 y 28 de Agosto 2026',
      location: 'Hotel AVA Resort, Cancún',
      registerNow: 'Nos vemos en 2027',
      viewAgenda: 'Ver Agenda',
      countdown: {
        days: 'Días',
        hours: 'Horas',
        minutes: 'Minutos',
        seconds: 'Segundos'
      }
    },
    // Relevancia
    relevance: {
      badge: 'Impacto sectorial',
      title: 'La Convención que Definió el Futuro',
      subtitle: 'ASOFOM representa a más de 200 entidades que impulsan la inclusión financiera en México. Esta convención reúne a los líderes que transforman el sector.',
      entities: 'Entidades Asociadas',
      years: 'Años de Trayectoria',
      days: 'Días de Contenido',
      attendees: 'Asistentes'
    },
    // Unique Edition
    unique: {
      badge: 'Edición 20 · Concluida',
      title: 'Lo Que Hizo Única Esta Edición',
      subtitle: 'Así celebramos 20 años de liderazgo: una experiencia sin precedentes que ya es historia',
      content: {
        title: 'Contenido de Alto Nivel',
        desc: 'Conferencias magistrales, paneles estratégicos y análisis profundo de las tendencias que están definiendo el sector financiero no bancario.'
      },
      speakers: {
        title: 'Speakers Internacionales',
        desc: 'Líderes globales compartieron perspectivas internacionales sobre innovación financiera, regulación y mejores prácticas del sector.'
      },
      networking: {
        title: 'Networking Estratégico',
        desc: 'Dueños de SOFOMes, directivos, inversores y tomadores de decisión conectaron en espacios diseñados para crear alianzas de valor.'
      },
      social: {
        title: 'Experiencias Sociales',
        desc: 'Cena de gala Black & White, The Grand Finale y experiencias que fortalecieron vínculos en ambientes exclusivos y memorables.'
      },
      sports: {
        title: 'Experiencias Deportivas',
        desc: 'Torneo de golf, boliche y carrera al amanecer frente al Caribe. Competencia amistosa que construyó relaciones duraderas.'
      },
      historic: {
        title: 'Edición 20 Histórica',
        desc: 'Dos décadas de impacto en el sector. Celebramos el legado y sentamos las bases del futuro del financiamiento en México.'
      }
    },
    // Agenda
    agenda: {
      badge: 'Así se vivió',
      title: 'Tres Días Que Hicieron Historia',
      subtitle: 'Conocimiento, conexiones y celebración: revive todo lo que sucedió en la edición 20',
      tabs: {
        content: 'Contenido',
        networking: 'Networking',
        social: 'Social',
        sports: 'Deportivo'
      },
      contentTab: {
        title: 'Contenido Estratégico de Alto Impacto',
        item1: 'Conferencias magistrales con líderes del sector financiero nacional e internacional',
        item2: 'Paneles especializados sobre regulación, tecnología financiera, riesgos y oportunidades de crecimiento',
        item3: 'Casos de éxito de SOFOMes líderes que han transformado el mercado',
        item4: 'Workshops prácticos con herramientas accionables para implementar en tu organización'
      },
      networkingTab: {
        title: 'Networking que Genera Valor',
        item1: 'Espacios exclusivos diseñados para facilitar conversaciones estratégicas entre tomadores de decisión',
        item2: 'Coffee breaks premium con tiempo suficiente para conectar con dueños y directivos de SOFOMes',
        item3: 'Mesas de negocio para reuniones uno a uno con aliados estratégicos y proveedores del sector',
        item4: 'Área de expositores donde conocerás las últimas soluciones tecnológicas y de servicios para SOFOMes'
      },
      socialTab: {
        title: 'Experiencias Sociales Memorables',
        item1: 'Cena de bienvenida en ambiente elegante para iniciar la convención con el pie derecho',
        item2: 'Gala de aniversario celebrando 20 años de ASOFOM con entretenimiento de primer nivel',
        item3: 'Coctel de clausura para cerrar con broche de oro tres días de experiencias inolvidables',
        item4: 'Actividades especiales que fortalecen vínculos y crean recuerdos duraderos con la comunidad ASOFOM'
      },
      sportsTab: {
        title: 'Competencias Deportivas de Alto Nivel',
        golf: 'Torneo de Golf',
        golfDesc: 'Competencia amistosa en campo de golf de clase mundial. Una oportunidad única para networking en un ambiente relajado mientras disfrutas de tu deporte favorito. Incluye premiación para los mejores lugares.',
        bowling: 'Torneo de Boliche',
        bowlingDesc: 'Diversión garantizada en nuestro torneo de boliche. Perfecto para romper el hielo y crear conexiones en un ambiente dinámico y entretenido. Premios para equipos ganadores y reconocimientos especiales.'
      }
    },
    // Speakers
    speakers: {
      badge: 'Speakers de clase mundial',
      title: 'Los Speakers Que Hicieron Historia',
      subtitle: 'Más de 60 líderes del sector financiero, regulatorio y empresarial compartieron su visión en la edición 20. Estos son los rostros que la hicieron inolvidable.',
      toBeAnnounced: 'Por Anunciar',
      followText: 'Mantente atento a nuestras redes sociales para conocer a los expertos de alto nivel que compartirán su visión del futuro financiero'
    },
    // Why Attend
    whyAttend: {
      badge: 'Audiencia estratégica',
      title: '¿Por Qué Asistir?',
      subtitle: 'Este evento está diseñado para quienes toman las decisiones que definen el sector',
      owners: {
        title: 'Dueños y Directivos de SOFOMes',
        desc: 'Líderes de sociedades financieras que buscan mantenerse a la vanguardia, conocer mejores prácticas y establecer alianzas estratégicas para impulsar el crecimiento de sus organizaciones.'
      },
      decisionMakers: {
        title: 'Tomadores de Decisión',
        desc: 'CEOs, CFOs y directores de área que necesitan entender el panorama regulatorio, identificar oportunidades de mercado y tomar decisiones informadas para sus organizaciones.'
      },
      partners: {
        title: 'Aliados Estratégicos',
        desc: 'Proveedores de tecnología, servicios financieros, consultoría y soluciones que buscan conectar con los principales players del sector y presentar sus propuestas de valor.'
      },
      authorities: {
        title: 'Autoridades y Actores del Ecosistema',
        desc: 'Representantes de organismos reguladores, asociaciones del sector, academia e instituciones que participan en la construcción del marco del financiamiento no bancario en México.'
      }
    },
    // Venue
    venue: {
      badge: 'Cancún, México',
      title: 'La Sede de una Edición Histórica',
      subtitle: 'Hotel AVA Resort Cancún - La sede que enmarcó una edición histórica frente al Caribe',
      hotelName: 'Hotel AVA Resort Cancún',
      hotelDesc: 'Resort de lujo all-inclusive ubicado en la espectacular zona hotelera de Cancún. Instalaciones de primer nivel, gastronomía excepcional y servicios premium para que tu experiencia sea inolvidable.',
      location: {
        title: 'Ubicación Privilegiada',
        desc: 'Zona hotelera de Cancún, frente al mar Caribe con acceso directo a playa privada'
      },
      facilities: {
        title: 'Instalaciones Premium',
        desc: 'Salones de eventos de última generación, espacios para networking y áreas recreativas'
      },
      experience: {
        title: 'Experiencia All-Inclusive',
        desc: 'Gastronomía internacional, bebidas premium y servicios de primera clase incluidos'
      },
      secureSpot: 'Asegura tu Lugar'
    },
    // Sponsors
    sponsors: {
      badge: 'Gracias a nuestros aliados',
      title: 'Las Marcas Que Lo Hicieron Posible',
      subtitle: 'Más de 60 empresas líderes respaldaron la 20ª Convención Nacional. Sold Out total.',
      comingSoon: 'Logos de patrocinadores próximamente',
      interested: '¿Quieres que tu marca esté en la 21ª Convención (2027)?',
      contact: 'Unirme a la lista de espera'
    },
    // Press
    press: {
      badge: 'Medios de comunicación',
      title: 'Contacto de Prensa',
      subtitle: 'Para entrevistas, información adicional o acreditación de medios',
      company: 'CyPress, Comunicación y Prensa',
      contacts: 'Contactos de Prensa',
      website: 'Sitio Web',
      whatsapp: 'WhatsApp'
    },
    // FAQ
    faq: {
      badge: 'Preguntas frecuentes',
      title: '¿Tienes Dudas?',
      subtitle: 'Encuentra respuestas a las preguntas más comunes sobre la convención',
      q1: {
        q: '¿Cuándo y dónde se llevará a cabo la convención?',
        a: 'La 20ª Convención Nacional ASOFOM se realizará del 26 al 28 de agosto de 2026 en el Hotel AVA Resort Cancún, ubicado en la zona hotelera de Cancún, México.'
      },
      q2: {
        q: '¿Qué incluye el registro?',
        a: 'El registro incluye acceso a todas las conferencias, paneles y workshops, material del evento, coffee breaks, comidas, eventos sociales (cóctel de bienvenida, cóctel bar, cena de gala) y eventos deportivos. Solo el torneo de golf tiene un costo adicional. También incluye acceso al área de expositores y certificado de asistencia.'
      },
      q3: {
        q: '¿Cómo puedo registrarme para los torneos deportivos?',
        a: 'Los torneos de golf y boliche tienen registro independiente y cupo limitado. Una vez completado tu registro principal, recibirás información detallada para inscribirte en las actividades deportivas de tu preferencia.'
      },
      q4: {
        q: '¿El hospedaje está incluido?',
        a: 'El hospedaje no está incluido en el registro, pero hemos negociado tarifas preferenciales en el Hotel AVA Resort Cancún para los asistentes. Detalles de reservación y tarifas especiales serán enviados una vez completes tu registro.'
      },
      q5: {
        q: '¿Habrá oportunidades de networking?',
        a: '¡Absolutamente! La convención está diseñada con múltiples espacios dedicados al networking: coffee breaks extendidos, cenas de gala, área de expositores, mesas de negocio y actividades sociales y deportivas que facilitan la conexión con otros líderes del sector.'
      },
      q6: {
        q: '¿Puedo llevar acompañantes?',
        a: 'Sí, puedes registrar acompañantes. El pase de acompañante incluye acceso a eventos sociales y actividades recreativas, pero no a las sesiones de contenido. Consulta tarifas y disponibilidad al momento de tu registro.'
      },
      q7: {
        q: '¿Cuál es la política de cancelación?',
        a: 'No hay cancelaciones ni reembolsos. Para información adicional sobre términos y condiciones, por favor contacta a nuestro equipo en mercadotecnia@asofom.mx o al 55 9000 4959.'
      }
    },
    // CTA Final
    finalCTA: {
      badge: 'Edición Especial 20 Años',
      title: 'Forma Parte de la Historia',
      subtitle: 'No te pierdas la convención más importante del sector financiero no bancario. Asegura tu lugar en esta edición especial de aniversario.',
      register: '¡Nos vemos en 2027!',
      limitedSpots: 'Cupo limitado • Registro anticipado disponible'
    },
    // Footer
    footer: {
      description: 'La Asociación de Sociedades Financieras de Objeto Múltiple en México A.C. representa al sector financiero no bancario más importante del país.',
      quickLinks: 'Enlaces Rápidos',
      about: 'Sobre la Convención',
      asofomSite: 'Sitio Web ASOFOM',
      contact: 'Contacto',
      privacy: 'Aviso de Privacidad',
      terms: 'Términos y Condiciones',
      rights: 'Todos los derechos reservados.'
    }
  },
  en: {
    // Navbar
    nav: {
      convention: 'Convention',
      agenda: 'Agenda',
      speakers: 'Speakers',
      venue: 'Venue',
      press: 'Press',
      register: 'See you in 2027'
    },
    // Hero
    hero: {
      badge: '20th Anniversary Edition',
      title1: '20th National Convention',
      title2: 'ASOFOM',
      subtitle: 'The most important gathering of the non-bank financial sector in Mexico. The Legacy unites us, the future moves us.',
      date: 'August 26, 27 & 28, 2026',
      location: 'AVA Resort Hotel, Cancun',
      registerNow: 'See you in 2027',
      viewAgenda: 'View Agenda',
      countdown: {
        days: 'Days',
        hours: 'Hours',
        minutes: 'Minutes',
        seconds: 'Seconds'
      }
    },
    // Relevancia
    relevance: {
      badge: 'Sector impact',
      title: 'The Convention that Defined the Future',
      subtitle: 'ASOFOM represents more than 200 entities that drive financial inclusion in Mexico. This convention brings together the leaders transforming the sector.',
      entities: 'Associated Entities',
      years: 'Years of Experience',
      days: 'Days of Content',
      attendees: 'Attendees'
    },
    // Unique Edition
    unique: {
      badge: '20th Edition · Concluded',
      title: 'What Made This Edition Unique',
      subtitle: 'This is how we celebrated 20 years of leadership: an unprecedented experience that is now history',
      content: {
        title: 'High-Level Content',
        desc: 'Keynote speeches, strategic panels and in-depth analysis of the trends defining the non-bank financial sector.'
      },
      speakers: {
        title: 'International Speakers',
        desc: 'Global leaders shared international perspectives on financial innovation, regulation and sector best practices.'
      },
      networking: {
        title: 'Strategic Networking',
        desc: 'SOFOM owners, executives, investors and decision-makers connected in spaces designed to create valuable partnerships.'
      },
      social: {
        title: 'Social Experiences',
        desc: 'Black & White gala dinner, The Grand Finale and experiences that strengthened bonds in exclusive and memorable settings.'
      },
      sports: {
        title: 'Sports Experiences',
        desc: 'Golf, bowling and a sunrise run by the Caribbean. Friendly competition that built lasting relationships.'
      },
      historic: {
        title: 'Historic 20th Edition',
        desc: 'Two decades of sector impact. We celebrated the legacy and laid the foundations for the future of financing in Mexico.'
      }
    },
    // Agenda
    agenda: {
      badge: 'How it was lived',
      title: 'Three Days That Made History',
      subtitle: 'Knowledge, connections and celebration: relive everything that happened at the 20th edition',
      tabs: {
        content: 'Content',
        networking: 'Networking',
        social: 'Social',
        sports: 'Sports'
      },
      contentTab: {
        title: 'High-Impact Strategic Content',
        item1: 'Keynote speeches with national and international financial sector leaders',
        item2: 'Specialized panels on regulation, financial technology, risks and growth opportunities',
        item3: 'Success stories from leading SOFOMs that have transformed the market',
        item4: 'Practical workshops with actionable tools to implement in your organization'
      },
      networkingTab: {
        title: 'Networking that Creates Value',
        item1: 'Exclusive spaces designed to facilitate strategic conversations between decision-makers',
        item2: 'Premium coffee breaks with enough time to connect with SOFOM owners and executives',
        item3: 'Business tables for one-on-one meetings with strategic partners and sector providers',
        item4: 'Exhibitor area where you\'ll discover the latest technological solutions and services for SOFOMs'
      },
      socialTab: {
        title: 'Memorable Social Experiences',
        item1: 'Welcome dinner in an elegant setting to start the convention on the right foot',
        item2: 'Anniversary gala celebrating 20 years of ASOFOM with world-class entertainment',
        item3: 'Closing cocktail to finish three days of unforgettable experiences with a flourish',
        item4: 'Special activities that strengthen bonds and create lasting memories with the ASOFOM community'
      },
      sportsTab: {
        title: 'High-Level Sports Competitions',
        golf: 'Golf Tournament',
        golfDesc: 'Friendly competition on a world-class golf course. A unique opportunity for networking in a relaxed environment while enjoying your favorite sport. Includes awards for top finishers.',
        bowling: 'Bowling Tournament',
        bowlingDesc: 'Guaranteed fun at our bowling tournament. Perfect for breaking the ice and creating connections in a dynamic and entertaining environment. Prizes for winning teams and special recognitions.'
      }
    },
    // Speakers
    speakers: {
      badge: 'World-class speakers',
      title: 'The Speakers Who Made History',
      subtitle: 'Over 60 leaders from the financial, regulatory and business sectors shared their vision at the 20th edition. These are the faces that made it unforgettable.',
      toBeAnnounced: 'To Be Announced',
      followText: 'Stay tuned to our social media to meet the high-level experts who will share their vision of the financial future'
    },
    // Why Attend
    whyAttend: {
      badge: 'Strategic audience',
      title: 'Why Attend?',
      subtitle: 'This event is designed for those who make the decisions that define the sector',
      owners: {
        title: 'SOFOM Owners and Executives',
        desc: 'Financial company leaders seeking to stay at the forefront, learn best practices and establish strategic alliances to drive organizational growth.'
      },
      decisionMakers: {
        title: 'Decision Makers',
        desc: 'CEOs, CFOs and department directors who need to understand the regulatory landscape, identify market opportunities and make informed decisions for their organizations.'
      },
      partners: {
        title: 'Strategic Partners',
        desc: 'Technology providers, financial services, consulting and solutions seeking to connect with key sector players and present their value propositions.'
      },
      authorities: {
        title: 'Authorities and Ecosystem Actors',
        desc: 'Representatives of regulatory bodies, sector associations, academia and institutions participating in building the framework for non-bank financing in Mexico.'
      }
    },
    // Venue
    venue: {
      badge: 'Cancun, Mexico',
      title: 'The Venue of a Historic Edition',
      subtitle: 'AVA Resort Hotel Cancun - The venue that framed a historic edition by the Caribbean',
      hotelName: 'AVA Resort Hotel Cancun',
      hotelDesc: 'Luxury all-inclusive resort located in the spectacular Cancun hotel zone. World-class facilities, exceptional gastronomy and premium services to make your experience unforgettable.',
      location: {
        title: 'Privileged Location',
        desc: 'Cancun hotel zone, facing the Caribbean Sea with direct access to private beach'
      },
      facilities: {
        title: 'Premium Facilities',
        desc: 'State-of-the-art event halls, networking spaces and recreational areas'
      },
      experience: {
        title: 'All-Inclusive Experience',
        desc: 'International gastronomy, premium beverages and first-class services included'
      },
      secureSpot: 'Secure Your Spot'
    },
    // Sponsors
    sponsors: {
      badge: 'Thanks to our partners',
      title: 'The Brands That Made It Possible',
      subtitle: 'Over 60 leading companies backed the 20th National Convention. Total Sold Out.',
      comingSoon: 'Sponsor logos coming soon',
      interested: 'Want your brand at the 21st Convention (2027)?',
      contact: 'Join the waitlist'
    },
    // Press
    press: {
      badge: 'Media',
      title: 'Press Contact',
      subtitle: 'For interviews, additional information or media accreditation',
      company: 'CyPress, Communication and Press',
      contacts: 'Press Contacts',
      website: 'Website',
      whatsapp: 'WhatsApp'
    },
    // FAQ
    faq: {
      badge: 'Frequently asked questions',
      title: 'Have Questions?',
      subtitle: 'Find answers to the most common questions about the convention',
      q1: {
        q: 'When and where will the convention take place?',
        a: 'The 20th National ASOFOM Convention will be held from August 26-28, 2026 at the AVA Resort Hotel Cancun, located in the Cancun hotel zone, Mexico.'
      },
      q2: {
        q: 'What does registration include?',
        a: 'Registration includes access to all conferences, panels and workshops, event materials, coffee breaks, meals, social events (welcome cocktail, cocktail bar, gala dinner) and sports events. Only the golf tournament has an additional cost. It also includes access to the exhibitor area and attendance certificate.'
      },
      q3: {
        q: 'How can I register for sports tournaments?',
        a: 'Golf and bowling tournaments have independent registration and limited capacity. Once you complete your main registration, you will receive detailed information to sign up for your preferred sports activities.'
      },
      q4: {
        q: 'Is accommodation included?',
        a: 'Accommodation is not included in registration, but we have negotiated preferential rates at AVA Resort Hotel Cancun for attendees. Reservation details and special rates will be sent once you complete your registration.'
      },
      q5: {
        q: 'Will there be networking opportunities?',
        a: 'Absolutely! The convention is designed with multiple spaces dedicated to networking: extended coffee breaks, gala dinners, exhibitor area, business tables and social and sports activities that facilitate connection with other sector leaders.'
      },
      q6: {
        q: 'Can I bring companions?',
        a: 'Yes, you can register companions. The companion pass includes access to social events and recreational activities, but not content sessions. Check rates and availability at registration.'
      },
      q7: {
        q: 'What is the cancellation policy?',
        a: 'There are no cancellations or refunds. For additional information on terms and conditions, please contact our team at mercadotecnia@asofom.mx or 55 9000 4959.'
      }
    },
    // CTA Final
    finalCTA: {
      badge: '20 Year Special Edition',
      title: 'Be Part of History',
      subtitle: 'Don\'t miss the most important convention in the non-bank financial sector. Secure your place at this special anniversary edition.',
      register: 'See you in 2027!',
      limitedSpots: 'Limited capacity • Early bird registration available'
    },
    // Footer
    footer: {
      description: 'The Association of Multi-Purpose Financial Societies in Mexico A.C. represents the most important non-bank financial sector in the country.',
      quickLinks: 'Quick Links',
      about: 'About the Convention',
      asofomSite: 'ASOFOM Website',
      contact: 'Contact',
      privacy: 'Privacy Policy',
      terms: 'Terms and Conditions',
      rights: 'All rights reserved.'
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('es');

  const t = (path) => {
    const keys = path.split('.');
    let value = translations[language];
    for (const key of keys) {
      value = value?.[key];
    }
    return value || path;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
